import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/shared/api/errors";

/**
 * Fabrique un `QueryClient`.
 *
 * Fabrique et non singleton : chaque test obtient un cache neuf, sinon le cache
 * d'un test rendrait le suivant vert à tort.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Réessayer une 4xx est inutile : la requête est en cause, pas le
          // réseau. Seules les erreurs serveur et réseau méritent un retry.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
